import { render, staticRenderFns } from "./PopupAddDataProcessor.vue?vue&type=template&id=4e36eefe&scoped=true&"
import script from "./PopupAddDataProcessor.vue?vue&type=script&lang=js&"
export * from "./PopupAddDataProcessor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e36eefe",
  null
  
)

export default component.exports